import URLBuilder from '@/lib/url-builder';

export default function contentAboutUsUrl(
  urlQuerySearchParams?: URLSearchParams | null | undefined,
  urlHash?: string | null | undefined,
): string {
  const url = new URLBuilder(`/o-nas`, urlQuerySearchParams, urlHash);
  return url.build();
}
